"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAutolinkRegex = exports.applyAutolinkIntegrationsToTextAsMarkdown = exports.applyAutolinkIntegrationsToTextAsHref = void 0;
const applyAutolinkIntegrationsToTextAsHref = (integrations, text) => {
    if (!integrations || integrations.length === 0) {
        return text;
    }
    return integrations.reduce((out, integration) => {
        return out.replace((0, exports.createAutolinkRegex)(integration.prefix), (match, num) => {
            const outputUrl = integration.url.replace("<num>", num);
            return `<a href="${outputUrl}" target="_blank" rel="noopener noreferrer">${match}</a>`;
        });
    }, text);
};
exports.applyAutolinkIntegrationsToTextAsHref = applyAutolinkIntegrationsToTextAsHref;
const applyAutolinkIntegrationsToTextAsMarkdown = (integrations, text) => {
    if (!integrations || integrations.length === 0) {
        return text;
    }
    return integrations.reduce((out, integration) => {
        return out.replace((0, exports.createAutolinkRegex)(integration.prefix), (match, num) => {
            const outputUrl = integration.url.replace("<num>", num);
            return `[${match}](${outputUrl})`;
        });
    }, text);
};
exports.applyAutolinkIntegrationsToTextAsMarkdown = applyAutolinkIntegrationsToTextAsMarkdown;
const createAutolinkRegex = (prefix) => {
    return new RegExp(`${escapeRegExp(prefix)}(\\d+)`, "gm");
};
exports.createAutolinkRegex = createAutolinkRegex;
// see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
function escapeRegExp(input) {
    return input.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}
//# sourceMappingURL=applyAutolinkIntegration.js.map